const common = {
  Test: 'Test',
  Save: '儲存',
};

export default common;
